import { Component, EventEmitter, Input, Output, ViewChild, AfterViewInit } from "@angular/core";
import { NgForm } from "@angular/forms";
import { User } from 'src/app/models/user'
import { Address } from "src/app/models/address";
import { FormValidationService } from "src/app/services/form-validation.service";
import { COUNTRIES } from "src/constants/validation-patterns";

enum FIELDS {
  NAME_TO_SHIP = 'nameToShip',
  SHIP_ADDRESS = 'shipAddress',
  ADD_SHIP_ADDRESS = 'addShipAddress',
  SHIP_CITY = 'shipCity',
  SHIP_POSTAL = 'shipPostal',
  SHIP_COUNTRY = 'shipCountry',
  SHIP_STATE = 'shipState',
}
@Component({
  selector: 'shipping-form',
  templateUrl: './shipping-form.html',
  styleUrls: ['./shipping-form.scss']
})

export class ShippingFormComponent implements AfterViewInit {

  @ViewChild('diffAddress') diffAddress: NgForm;
  @Input() guest: User = {} as User;
  @Input() countriesList: Array<any> = [];
  @Input() differentAddressStatesList: Array<any> = [];
  @Input() shippingAddress: Address = {} as Address;
  @Input() submittedAccountForm: boolean = false;
  @Input() couponValidation: boolean = false;
  @Input() shipToName: string = '';
  @Input() euSpecified: boolean = false;
  @Input() braintreeDefaultCountry: string = 'United States';

  @Output() linkForm = new EventEmitter();
  @Output() validateAddressAndCalculateTaxes = new EventEmitter<string>();
  @Output() rememberAccountInformation = new EventEmitter<void>();
  @Output() shipToNameBinder = new EventEmitter<string>();
  @Output() countryChange = new EventEmitter();
  @Output() stateChange = new EventEmitter();
  @Output() countryShippingChange = new EventEmitter();
  readonly FIELDS = FIELDS;
  
  // Private alias for cleaner code - initialized in constructor
  private vs!: FormValidationService;

  // Expose validation patterns for template use
  readonly errorImage: string = this.formValidationService.errorImage;
  emailPattern: string = this.formValidationService.emailPattern;
  textPattern: string = this.formValidationService.textPattern;
  mixedPattern: string = this.formValidationService.mixedPattern;
  usaZipPattern: string = this.formValidationService.usaZipPattern;
  canadianPostalPattern: string = this.formValidationService.canadianPostalPattern;
  numberPattern: string = this.formValidationService.numberPattern;
  phonePattern: string = this.formValidationService.phonePattern;
  addressPattern: string = this.formValidationService.addressPattern;

  constructor(public formValidationService: FormValidationService) {
    // Initialize alias for cleaner code
    this.vs = this.formValidationService;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.setupFormValidators();
      if (this.diffAddress) {
        this.linkForm.emit(this.diffAddress);
      }
    }, 0);
  }

  /**
   * Handles blur event on postal code field to trigger validation
   */
  onPostalCodeBlur(): void {
    this.vs.onPostalCodeBlur(this.diffAddress, String(this.FIELDS.SHIP_POSTAL));
  }

  validate_AddressAndCalculateTaxes(address: string) {
    // Revalidate postal code when address/country changes
    const country = this.shippingAddress?.country || this.braintreeDefaultCountry || COUNTRIES.UNITED_STATES;
    this.vs.revalidatePostalCode(
      this.diffAddress,
      String(this.FIELDS.SHIP_POSTAL),
      country,
      this.braintreeDefaultCountry
    );
    this.validateAddressAndCalculateTaxes.emit(address);
  }

  remember_AccountInformation() {
    this.rememberAccountInformation.emit();
  }

  bindShipToName() {
    this.shipToNameBinder.emit(this.shipToName);
  }
  getLabel(label: string) {
    return this.vs.getCheckoutLabel(label, this.braintreeDefaultCountry);
  }

  getLabelShipping(label: string) {
    return this.vs.getShippingLabel(label, this.braintreeDefaultCountry);
  }

  /**
   * Returns the appropriate pattern for postal/zip code based on country
   * Used in HTML template for client-side validation
   */
  getPostalCodePattern(): string {
    const country = this.shippingAddress?.country || this.braintreeDefaultCountry || COUNTRIES.UNITED_STATES;
    return this.vs.getPostalCodePattern(country, this.braintreeDefaultCountry);
  }

  isFacebookApp() {
    return this.vs.isFacebookApp();
  }

  // Display the state field if it is not included in the hideStateByCountryList
  displayStateField() {
    return this.vs.displayStateField(this.shippingAddress.country);
  }

  onCountryChange() {
    this.countryChange.emit(true);
    //this.confirmAddress();
  }

  onCountryShippingChange() {
    this.countryShippingChange.emit(true);
  } 

  onStateChange() {
    this.stateChange.emit(true);
    //this.confirmAddress();
  }

  private setupFormValidators(): void {
    if (!this.diffAddress?.controls) {
      return;
    }

    const country = this.shippingAddress?.country || this.braintreeDefaultCountry || COUNTRIES.UNITED_STATES;

    // NAME_TO_SHIP - name validators
    this.vs.setFieldValidators(
      this.diffAddress,
      String(this.FIELDS.NAME_TO_SHIP),
      this.vs.getNameValidators()
    );

    // STREET - required with address pattern
    this.vs.setFieldValidators(
      this.diffAddress,
      String(this.FIELDS.SHIP_ADDRESS),
      this.vs.getAddressValidators()
    );

    // CITY - required with text pattern
    this.vs.setFieldValidators(
      this.diffAddress,
      String(this.FIELDS.SHIP_CITY),
      this.vs.getCityValidators()
    );

    // ZIP_POSTAL_CODE - uses custom validator based on country
    this.vs.setFieldValidators(
      this.diffAddress,
      String(this.FIELDS.SHIP_POSTAL),
      this.vs.getPostalCodeValidators(country, this.braintreeDefaultCountry)
    );
  }

  facebookAppShippingStateChangeHandler() {
    try {
      let fbshippingcountry = (document.querySelector('#FBShippingCountryCode') as any).value
      if (!fbshippingcountry || fbshippingcountry == '') fbshippingcountry = 'US';
      let FBStates = ((window as any)['countries']).find(({ value }: { [key: string]: any }) => value === fbshippingcountry);
      if (!FBStates) return;
      let FBState = FBStates.states;
      (document.querySelector('#facebookshippingstate') as any).value = FBState[(document.querySelector('#FBShippingStateCode') as any).value];
      if (this.diffAddress.form.controls.shipAddress.value == this.diffAddress.form.controls.addShipAddress.value) {
        this.diffAddress.form.controls.addShipAddress.patchValue('');
        this.diffAddress.form.controls.addShipAddress.markAsDirty();
        this.diffAddress.form.controls.addShipAddress.updateValueAndValidity();
      }
      if (FBStates.label != '' && FBStates.label != this.diffAddress.form.controls.shipCountry.value) {
        this.diffAddress.form.controls.shipCountry.patchValue(FBStates.label);
        this.diffAddress.form.controls.shipCountry.markAsDirty();
        this.diffAddress.form.controls.shipCountry.updateValueAndValidity();
        this.diffAddress.form.markAsDirty();
        this.validate_AddressAndCalculateTaxes('shipping');

        this.onCountryChange();
      }
      setTimeout(() => {
        if (FBState[(document.querySelector('#FBShippingStateCode') as any).value] != '') {
          this.diffAddress.form.controls.shipState.patchValue(FBState[(document.querySelector('#FBShippingStateCode') as any).value]);
          this.diffAddress.form.controls.shipState.markAsDirty();
          this.diffAddress.form.controls.shipState.updateValueAndValidity();
        }
        if (document.querySelector('#FBShippingStateCode') && (document.querySelector('#FBShippingStateCode') as any).value != '') {

          if (document.querySelector('#FBShippingStateCode') && (document.querySelector('#FBShippingStateCode') as any).value != '' && (document.querySelector('#FBShippingStateCode') as any).value.length > 2) {
            this.diffAddress.form.controls.shipState.patchValue((document.querySelector('#FBShippingStateCode') as any).value);
            this.diffAddress.form.controls.shipState.markAsDirty();
            this.diffAddress.form.controls.shipState.updateValueAndValidity();
          } else {
            this.diffAddress.form.controls.shipState.patchValue(FBState[(document.querySelector('#FBShippingStateCode') as any).value]);
            this.diffAddress.form.controls.shipState.markAsDirty();
            this.diffAddress.form.controls.shipState.updateValueAndValidity();
          }
        }
        if (!this.diffAddress.form.controls.shipAddress.value && (document.querySelector('#FBAddressLine1') as any).value != '') {
          this.diffAddress.form.controls.shipAddress.patchValue((document.querySelector('#FBAddressLine1') as any).value);
          this.diffAddress.form.controls.shipAddress.markAsDirty();
          this.diffAddress.form.controls.shipAddress.updateValueAndValidity();
        }
        if (!this.diffAddress.form.controls.addShipAddress.value && (document.querySelector('#FBAddressLine2') as any).value != '') {
          this.diffAddress.form.controls.addShipAddress.patchValue((document.querySelector('#FBAddressLine2') as any).value);
          this.diffAddress.form.controls.addShipAddress.markAsDirty();
          this.diffAddress.form.controls.addShipAddress.updateValueAndValidity();
        }
        this.diffAddress.form.markAsDirty();
        this.validate_AddressAndCalculateTaxes('shipping');
        this.onStateChange();


      }, 300)
    } catch (e) {
      console.log('Facebook app shipping state changed', e);
    }
  }
}